import { z } from "zod";

export const shippingTrackingSchema = z.object({
  orderNumber: z
    .string()
    .min(1, "Sipariş numarası zorunludur")
    .regex(/^[A-Z0-9\-]+$/, "Geçersiz sipariş numarası formatı"),
  phoneNumber: z
    .string()
    .min(10, "Telefon numarası tamamlanmalıdır")
    .max(10, "Telefon numarası geçersiz"),
});

export type ShippingTrackingData = z.infer<typeof shippingTrackingSchema>;
